export const teamPlayerRoles = {
  CEO: 'CEO',
  PD: 'Product',
  PM: 'Marketing',
  OP: 'Operations',
  FI: 'Finance'
}

export const teamPlayerRowsPerPage = {
  25: 25,
  50: 50,
  75: 75,
  100: 100
};


// WEBPACK FOOTER //
// ./src/instructor/constants.js